import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { GroupDetailListingModel, GroupDetailsGridPostParams } from 'common/models/page-models/groups/group-details/group-detail-grid-model';
import { GroupDetailModel } from 'common/models/page-models/groups/group-details/group-detail-model';

@Injectable({
    providedIn: 'root'
})
export class StudentListDataService extends GridDataService<GroupDetailListingModel, GroupDetailModel> {
    groupDetailData: any = {}
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.studentListBatchwise, http, ss);
    }

    createInstance(): GroupDetailListingModel {
        return new GroupDetailListingModel();
    }

    getDeleteUrl() {
        return '';
    }

    override getGridParams(): GridPostParams {
        return new GroupDetailsGridPostParams();
    }

    override modifyGridPostParams(queryParams) {
        let payload = this.getGridParams();
        if (queryParams !== null) {
            payload['batch_id'] = queryParams?.transferData?.batch_id;
        }
        return payload;
    }

    override async getData(data): Promise<any> {
        return await new Promise((resolve, reject) => {
            Promise.resolve()
                .then((event) => {
                    resolve(this.getDataById(data));
                })
                .catch((err) => {
                    reject(err);
                });

        })
    }

    override modifyAPIResponse(response: any) {
        this.groupDetailData = response['details'];
        this.systemService.setlocalStorage('groupInfo', response['details']);
        return response['details'];
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.getGroupById,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data: any) {
        let payload;

        payload = {
            id: data.id

        }
        return payload;
    }

    override transformDataModel(apiRes: any, param: string) {
        super.transformDataModel(apiRes, 'details');
        if (this.groupDetailData.hasOwnProperty('student_list') && this.groupDetailData.student_list.length > 0) {
            apiRes[param] = this.groupDetailData.student_list;
            apiRes[param].forEach((data) => {
                data.id = data.student_id;
                data.region = this.getRegion(parseInt(data.region_id));
            });
        } else {
            apiRes[param].forEach((item) => {
                item.group_student_list_id = null; 
            })
        }
        return apiRes;
    }

    override getModifiedGridModel(apiRes: any, gridModel: any) {
        gridModel['alreadyAddedStudents'] = gridModel.originalModel.filter((student) => student.group_student_list_id !== null);
        gridModel['selectedStudents'] = [];
        gridModel['removedStudents'] = [];
        return gridModel;
    }

    getRegion(region) {
        switch (region) {
            case 1:
                return 'North';
            case 2:
                return 'South';
            case 3:
                return 'East';
            case 4:
                return 'West';
            default:
                return '-';
        }
    }
}
